<script>
    import { getContext } from "svelte";
    import { key as contentDresonRuleCtxKey } from "../context/contentDresonRule";

    /**
 *
 *
 *
 *
 *
 */

    /*                */
    let { benefitDiscountValuePercent, benefitId = null, variationId, featuresState } = $props();

    const showBottomBenefitBadge = $derived(benefitId && benefitDiscountValuePercent);

    const contentDresonRule = getContext(contentDresonRuleCtxKey);

    const contentDresonRuleParam = contentDresonRule ? `&contextDreson=${contentDresonRule}` : "";

    /*                                                                                                           */
    const benefitBadgeUrl = `/benefit-sheet/sheet/reco/${benefitId}?useOcSheet=true${contentDresonRuleParam}`;
</script>

{#if featuresState?.USE_FT9_BENEFIT_BADGE_COMPONENT}
    <ft9-benefit-tag-v1
        class="reco_cinema__benefit-tag"
        id={`benefit_discount_badge_${variationId}`}
        team="ft6-bcn"
        feature="reco"
        variation-id={variationId}
        data-testid="ft9_benefit_badge_{variationId}"
        remove-expired
        load-on-visibility
        current-context-dreson={contentDresonRule ?? "(und.(ja).(~.(v.1)))"}
    >
    </ft9-benefit-tag-v1>
{:else if showBottomBenefitBadge}
    <oc-tag-v1
        data-oc-sheet-v1-create
        data-oc-sheet-v1-create.base64-url={btoa(benefitBadgeUrl)}
        data-oc-sheet-v1-create.id="reco_cinema_benefit_badge_{benefitId}"
        data-testid="reco_cinema_benefit_badge_{benefitId}"
        class="reco_cinema__customer-benefit-badge oc-mt-25"
        size="50"
        variant="sale"
        show-info-icon
        >{benefitDiscountValuePercent}
    </oc-tag-v1>
{/if}

<style lang="scss">
    @use "@otto-ec/design-tokens/tokens" as tokens;
    .reco_cinema__benefit-tag {
        top: tokens.$oc-semantic-spacing-25;
        position: relative;
    }
</style>
